import { FieldPath, UseFormReturn } from "react-hook-form";

import { OptionalLabel } from "@/components/OptionalLabel";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { cn } from "@/lib/utils";

export const FormTimeInput = <T extends Record<string, unknown>>({
  className,
  disabled,
  fieldName,
  form,
  inputClassName,
  label,
  optional,
}: {
  className?: string;
  disabled?: boolean;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  inputClassName?: string;
  label: string;
  optional?: boolean;
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            <FormLabel>
              {label}
              {optional && <OptionalLabel className="ml-1.5" />}
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                className={inputClassName}
                disabled={disabled}
                type="time"
                value={field.value as string}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
